import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[appOpenUrl]',
})
export class OpenUrlDirective {
  @Input('appOpenUrl') url: string = '';

  constructor(private router: Router) {}

  @HostListener('click', ['$event'])
  onClick($event: MouseEvent): void {
    if ($event.ctrlKey || $event.metaKey) {
      // ctrl was held during click
      window.open(this.url, '_blank');
    } else {
      void this.router.navigate([this.url]);
    }
  }
}
